@let table = wartungen$ | async;
@let hasData = table?.rows.length > 0;
@let showRows = filteredRows();
@if(authService.getRight('view', 'AllowVWART')) {
    <div class="clr-row nxm clr-justify-content-between clr-align-items-center">
    <div class="clr-col-auto margin-12-tb">
      @if (!isMultiMode()) {
        <div class="btn-group btn-primary">
          <button class="btn" (click)="openWartung('neu')" [disabled]="!selectedNode()?.mID">
            <cds-icon shape="file" [title]="'Neue Wartung durchführen' | mrTranslate" />
            {{ 'neu' | mrTranslate }}
          </button>
          <button class="btn" (click)="openWartung('readonly')" [disabled]="!selectedNode()?.wID">
            <cds-icon shape="folder-open" [title]="'Letzte Wartung öffnen' | mrTranslate" />
            {{ 'öffnen' | mrTranslate }}
          </button>
          <button class="btn" (click)="openWartung()" [disabled]="!selectedNode()?.wID">
            <cds-icon shape="note" [title]="'Letzte Wartung bearbeiten' | mrTranslate" />
            {{ 'bearbeiten' | mrTranslate }}
          </button>
        </div>
      } @else {
        <div class="btn-group">
          <button class="btn btn-primary" (click)="multiModal.open()" [disabled]="!selectedNodes().length">
            <cds-icon shape="step-forward-2" [title]="'Auswahl bestätigen' | mrTranslate" />
            {{ 'auswählen' | mrTranslate }}
          </button>
        </div>
      }
      <div class="btn-group btn-icon">
        @if (!isRep) {
          <button class="btn" (click)="openVerwaltung()">
            <cds-icon shape="cog" [title]="'Wartungsverwaltung öffnen' | mrTranslate" />
          </button>
        }
        <button class="btn" (click)="toggleMulti()">
          @let shape = isMultiMode() ? 'times-circle' : 'layers';
          @let title = isMultiMode() ? 'abbrechen' : 'öffnen';
          <cds-icon
            [shape]="shape"
            solid="true"
            [title]="('Sammelrückmeldung' | mrTranslate) + ' ' + (title | mrTranslate)" />
        </button>
        <button class="btn" (click)="getExcelList()">
          <clr-tooltip>
            <cds-icon clrTooltipTrigger shape="excel" />
            <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
              {{ 'Liste nach Excel exportieren' | mrTranslate }}
            </clr-tooltip-content>
          </clr-tooltip>
        </button>
        <button class="btn" (click)="filterStore.deleteAllFilters()" [disabled]="table?.rows.length == showRows?.length">
          <clr-tooltip>
            <cds-icon clrTooltipTrigger shape="filter-off" />
            <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
              {{ 'Alle Filter zurücksetzen' | mrTranslate }}
            </clr-tooltip-content>
          </clr-tooltip>
        </button>
      </div>
    </div>
    <div class="clr-col-auto margin-12-tb">
      <div class="btn-group btn-icon">
        @if (!isRep) {
          <button
            class="btn"
            [title]="'Replikat für Wartungen erstellen' | mrTranslate"
            [disabled]="!allowRepErstellen"
            (click)="isUserReplikatModalOpen.set(true)">
            <cds-icon size="20" shape="rep_user" />
          </button>
        } @else if (hasData) {
          <button class="btn" [title]="'Replikat zurückspielen' | mrTranslate" (click)="stopReplicate()">
            <cds-icon size="20" shape="rep_upload" />
          </button>
        }
        <button
          class="btn"
          [disabled]="!selectedNode()?.OSTAMMID"
          (click)="historiePanel.open(); isHistorieInitialized.set(true)">
          <cds-icon shape="tree-view" [title]="'Historie öffnen' | mrTranslate" />
        </button>
      </div>
    </div>
  </div>
}

<div class="padding-10-lr padding-12-b w-100-p h-60">
  @if (!isLoading() && table) {
    @if (hasData) {
      @if (!isMultiMode()) {
        <clr-datagrid
          class="datagrid-compact h-100-force"
          [deselectButton]="true"
          [clrDgItemsIdentityFn]="row => row?.ID"
          [clrDgRowSelection]="true"
          [clrDgSelectionType]="'single'"
          [clrDgSelected]="[selectedNode()]"
          (clrDgSelectedChange)="selectedNode.set($event[0])">
          <clr-dg-column class="mw-0" clrDgField="typ">
            @let column = { id: 'typ', type: 'string' };
            <clr-dg-filter [attr.data-test-id]="'datagrid-wartungen-col-filter-' + column.id">
              <app-column-filter
                [column]="column"
                [objektTypIconValue]="filterStore.iconMap()"
                [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                (changes)="filterStore.onChange($event)" />
            </clr-dg-filter>
            <ng-container>{{ 'Typ' | mrTranslate }}</ng-container>
          </clr-dg-column>
          <clr-dg-column class="mw-0" clrDgField="RevBild">
            {{ 'Media' | mrTranslate }}
          </clr-dg-column>
          @for (column of table.columns; track column.id) {
            <clr-dg-column [clrDgField]="column.id" [clrDgSortOrder]="column.id == 'nextDatum' ? 1 : 0">
              @let title =
                column.id == 'nextDatum' ? 'Nächste Wartung'
                : column.id == 'letzteDatum' ? 'Letzte Wartung'
                : column.id == 'diffFromNow' ? 'Fälligkeit in Tagen'
                : null;
              <clr-dg-filter [attr.data-test-id]="'datagrid-wartungen-col-filter-' + column.id">
                <app-column-filter
                  [column]="column"
                  [title]="title"
                  [objektTypIconValue]="filterStore.iconMap()"
                  [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                  (changes)="filterStore.onChange($event)" />
              </clr-dg-filter>

              <ng-template
                [clrDgHideableColumn]="{ hidden: column.id | hideIDColumns: hides() }"
                (clrDgHiddenChange)="columnHiddenChange()">
                {{ title ?? (column.id | titlecase) | mrTranslate }}
              </ng-template>
            </clr-dg-column>
          }
          <ng-template
            clrVirtualScroll
            let-row
            [clrVirtualRowsOf]="showRows"
            [clrVirtualRowsMaxBufferPx]="3000"
            [clrVirtualRowsTrackBy]="(_, row) => row?.ID">
            <clr-dg-row [clrDgItem]="row">
              <clr-dg-cell class="mw-0">
                <cds-icon
                  size="26"
                  class="grid-icon fill-black"
                  [title]="row.typ"
                  [shape]="row.icon ? 'objekttyp' + row.icon : 'unknown-status'" />
              </clr-dg-cell>
              <clr-dg-cell class="mw-0">
                <div style="width: max-content; margin: 5px auto 0">
                  <a
                    class="nav-link nav-icon"
                    href="javascript:void(0);"
                    (click)="setWartungMedia(row); $event.stopPropagation()"
                    [class.deactivate]="!row.RevBild">
                    <cds-icon
                      [shape]="!row.RevBild ? 'blank' : 'image-gallery'"
                      size="20"
                      [title]="'Media anzeigen' | mrTranslate" />
                  </a>
                </div>
              </clr-dg-cell>
              @for (cell of table.columns; track cell.id) {
                @if (cell.id == 'diffFromNow') {
                  <clr-dg-cell class="name-cell" [class.invalid-red]="row.diffFromNow < 3">
                    @if (row.diffFromNow < 0) {
                      <cds-icon class="grid-icon invalid-red margin-3-r" size="20" shape="exclamation-triangle" />
                    }
                    <span>{{ row.diffFromNow }}</span>
                  </clr-dg-cell>
                } @else {
                  <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint | mrTranslate }}</clr-dg-cell>
                }
              }
            </clr-dg-row>
          </ng-template>
          <clr-dg-footer>
            <div class="footerbox">
              <div>
                <button class="minibutton" [title]="'Spaltenfilter löschen' | mrTranslate" (click)="removeColFilter()">
                  <cds-icon shape="filter-off" />
                </button>
              </div>
              <div class="dbNameTable">{{ formatDBName }}</div>
              <div>{{ showRows.length }} {{ 'Zeilen' | mrTranslate }}</div>
            </div>
          </clr-dg-footer>
        </clr-datagrid>
      } @else {
        <clr-datagrid
          class="datagrid-compact h-100-force"
          [clrDgItemsIdentityFn]="row => row?.ID"
          [clrDgSelectionType]="'multi'"
          [clrDgSelected]="selectedNodes()"
          (clrDgSelectedChange)="selectedNodes.set($event)">
          <clr-dg-column class="mw-0" clrDgField="typ">
            @let column = { id: 'typ', type: 'string' };
            <clr-dg-filter [attr.data-test-id]="'datagrid-wartungen-col-filter-' + column.id">
              <app-column-filter
                [column]="column"
                [objektTypIconValue]="filterStore.iconMap()"
                [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                (changes)="filterStore.onChange($event)" />
            </clr-dg-filter>
            <ng-container>{{ 'Typ' | mrTranslate }}</ng-container>
          </clr-dg-column>
          @for (column of table.columns; track column.id) {
            <clr-dg-column [clrDgField]="column.id" [clrDgSortOrder]="column.id == 'nextDatum' ? 1 : 0">
              @let title =
                column.id == 'nextDatum' ? 'Nächste Wartung'
                : column.id == 'letzteDatum' ? 'Letzte Wartung'
                : column.id == 'diffFromNow' ? 'Fälligkeit in Tagen'
                : null;
              <clr-dg-filter [attr.data-test-id]="'datagrid-wartungen-col-filter-' + column.id">
                <app-column-filter
                  [column]="column"
                  [title]="title"
                  [objektTypIconValue]="filterStore.iconMap()"
                  [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                  (changes)="filterStore.onChange($event)" />
              </clr-dg-filter>

              <ng-template
                [clrDgHideableColumn]="{ hidden: column.id | hideIDColumns: hides() }"
                (clrDgHiddenChange)="columnHiddenChange()">
                {{ title ?? (column.id | titlecase) | mrTranslate }}
              </ng-template>
            </clr-dg-column>
          }
          <ng-template
            clrVirtualScroll
            let-row
            [clrVirtualRowsOf]="showRows"
            [clrVirtualRowsTrackBy]="(_, row) => row?.ID">
            <clr-dg-row [clrDgItem]="row" [clrDgSelectable]="row.mID > 0">
              <clr-dg-cell class="mw-0">
                <div style="width: max-content; margin: 5px auto 0">
                  <cds-icon
                    style="color: black"
                    [shape]="row['icon'] ? 'objekttyp' + row['icon'] : 'unknown-status'"
                    size="28" />
                </div>
              </clr-dg-cell>
              @for (cell of table.columns; track cell.id) {
                @if (cell.id == 'diffFromNow') {
                  <clr-dg-cell class="name-cell" [class.invalid-red]="row.diffFromNow < 3">
                    @if (row.diffFromNow < 0) {
                      <cds-icon class="grid-icon invalid-red margin-3-r" size="20" shape="exclamation-triangle" />
                    }
                    <span>{{ row.diffFromNow }}</span>
                  </clr-dg-cell>
                } @else {
                  <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint | mrTranslate }}</clr-dg-cell>
                }
              }
            </clr-dg-row>
          </ng-template>
          <clr-dg-footer>
            <div class="footerbox">
              <div>
                <button class="minibutton" [title]="'Spaltenfilter löschen' | mrTranslate" (click)="removeColFilter()">
                  <cds-icon shape="filter-off" />
                </button>
              </div>
              <div class="dbNameTable">{{ formatDBName }}</div>
              <div>{{ showRows.length }} {{ 'Zeilen' | mrTranslate }}</div>
            </div>
          </clr-dg-footer>
        </clr-datagrid>
      }
    } @else {
      <div>{{ 'keine Daten vorhanden' | mrTranslate }}</div>
    }
  } @else {
    <div class="d-f center h-100"><clr-spinner /></div>
  }
</div>
<clr-side-panel #historiePanel class="h-100-stop" [clrSidePanelSize]="historieDetailSize()">
  <h3 class="side-panel-title">
    <div class="btn-group">
      <app-expand-buttons [(ansichtMode)]="expandedState" [hideSplitIfWidthLess]="900" [hideExpandIfWidthLess]="600" />
    </div>
    {{ 'Historie' | mrTranslate }}
  </h3>
  <div class="side-panel-body h-100 h-100-parent">
    <div class="padding-12-b">
      <strong class="caption nm">
        {{ selectedNode()?.strBez || ('Objekt' | mrTranslate) }}
      </strong>
    </div>
    <div class="h-60">
      @if (isHistorieInitialized()) {
        <app-historie-tree [ostammid]="selectedNode()?.OSTAMMID" />
      }
    </div>
  </div>
  <div class="side-panel-footer">
    <button type="button" class="btn btn-outline" (click)="historiePanel.close()">
      {{ 'Schliessen' | mrTranslate }}
    </button>
  </div>
</clr-side-panel>

<clr-modal #multiModal [clrModalClosable]="true" (clrModalOpenChange)="!$event && clearMulti()">
  <h3 class="modal-title">{{ 'Sammelrückmeldung' | mrTranslate }}</h3>
  <div class="modal-body clr-row nxm">
    <form clrForm #f="ngForm" class="clr-col-12 width100" clrLayout="horizontal">
      <clr-date-container>
        <label for="date">{{ 'Datum' | mrTranslate }}</label>
        <input
          type="date"
          clrDate
          name="wdatum"
          [ngModel]="datumModel() | localeDate"
          (ngModelChange)="datumModel.set(localeDate.tosql($event))"
          [ngModelOptions]="{ updateOn: 'blur' }"
          required />
        <clr-control-error *clrIfError="'required'">
          {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
        </clr-control-error>
      </clr-date-container>
      <clr-control-container>
        <label class="clr-col-12 clr-col-md-12">
          {{ 'Bemerkung' | mrTranslate }}
        </label>
        <app-datalist-input
          [datalist]="bemerkungen$ | async"
          name="bemerkung"
          class="clr-col-12 clr-col-md-12 w-100-p"
          [(ngModel)]="bemerkungModel" />
      </clr-control-container>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn" (click)="multiModal.close()">
      {{ 'Abbrechen' | mrTranslate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="sendMultiWartung(multiModal)" [disabled]="f.invalid">
      {{ 'OK' | mrTranslate }}
    </button>
  </div>
</clr-modal>

<app-mediaviewmodal
  (onClose)="wartungsMedia.set(undefined)"
  [srcs]="wartungsMedia()"
  [getMediaFromServerAll]="media.getApiFunctionMedia"
  [getBigFileFnc]="media.getApiFunctionMediaBig" />

@if (isReplikatProgressOpen()) {
  <app-replikat-progress
    [mode]="isRep ? 'syncback' : 'setup'"
    [setupConfig]="setupConfig()"
    [(modalOpen)]="isReplikatProgressOpen" />
}

@if (isUserReplikatModalOpen()) {
  <app-replikat-wartungen-setup
    [(setupConfig)]="setupConfig"
    (setupConfigChange)="isReplikatProgressOpen.set(true)"
    [(modalOpen)]="isUserReplikatModalOpen" />
}
